var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FF9100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1564 4.08466C35.198 -1.36156 42.802 -1.36155 45.8436 4.08467L76.9295 59.746C79.9711 65.1922 76.1691 72 70.0859 72H7.91413C1.8309 72 -1.97111 65.1922 1.07051 59.746L32.1564 4.08466ZM41.9655 63C41.9655 64.6569 40.6224 66 38.9655 66C37.3087 66 35.9655 64.6569 35.9655 63C35.9655 61.3431 37.3087 60 38.9655 60C40.6224 60 41.9655 61.3431 41.9655 63ZM42 15C42 13.3431 40.6569 12 39 12C37.3431 12 36 13.3431 36 15V50.9997C36 52.6565 37.3431 54 39 54C40.6568 54 42 52.6556 42 50.9987V15Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.80c58426121585aea0c4029f6c1ba958.svg";
export { ForwardRef as ReactComponent };